/**
* ui.inputFormDialog.js
*
* This file is DEPRECATED. It's still used for RXs and some orders.
*/

goog.provide('el8.uiwidget.InputFormDialog');

goog.require('el8.util.base');
goog.require('el8.util.event');
goog.require('el8.uiwidget.Dialog');


el8.uiwidget.InputFormDialog = function( spec ) {

    var that = {};
    var container = spec.container;

    // -----------------------------
    // Construct UI dialog
    // -----------------------------
    var containerId = spec.containerId || '';
    var title = spec.title || null;
    var dialogWidth = spec.dialogWidth || 800;
    var dialogHeight = spec.dialogHeight || 300;
    var dialogRightMargin = spec.dialogRightMargin || null;
    var dialogBottomMargin = spec.dialogBottomMargin ? (spec.dialogBottomMargin + 30) : null; // add 30 for bottom padding
    var buttons = spec.buttons || {};
    var makeExpandable = ( spec.makeExpandable !== false ); // default to true
    var disableTitlebarClose = (spec.disableTitlebarClose === true); // default to false
    var disableTitlebarMinimize = (spec.disableTitlebarMinimize === true); // default to false
    var disableTitlebarExpand = (spec.disableTitlebarExpand === true); // default to false
    var isModal = (spec.isModal === true); // default to false
    var minimizeFn = spec.minimizeFn || function() {};
    var closeFn = spec.closeFn || function() {};
    var savedOffsets = spec.savedOffsets || null;
    var focus = spec.focus || null;
    var blur = spec.blur || null;
    var position = spec.position || null;

    function setDialogSize() {
       container.height( dialog.getDialogHeight() - 55 );
    }

    var dialog = container.el8_inputDialog({
        title: title,
        preferredWidth: dialogWidth,
        preferredHeight: dialogHeight,
        rightMargin: dialogRightMargin,
        bottomMargin: dialogBottomMargin,
        position: position,
        disableTitlebarClose: disableTitlebarClose,
        disableTitlebarMinimize: disableTitlebarMinimize,
        disableTitlebarExpand: disableTitlebarExpand,
        isModal: isModal,
        closeFn: closeFn,
        minimizeFn: minimizeFn,
        containerId: containerId,
        buttons: buttons,
        resizeFn: setDialogSize,
        savedOffsets: savedOffsets,
        focus: focus,
        blur: blur
    });

    if( makeExpandable ) {
        dialog.makeExpandable({
            expandFn: function() {
                setDialogSize();
                dialog.getExpandTrigger().addClass('restoreButton').removeClass('maximizeButton');
            },
            restoreFn: function() {
                setDialogSize();
                dialog.getExpandTrigger().addClass('maximizeButton').removeClass('restoreButton');
            }
        });

        var expanded = false;

        dialog.getExpandTrigger().unbind('click').on('click', function(event) {
            event.preventDefault();
            if( expanded ) {
                dialog.restoreHeight();
                expanded = false;
            } else {
                dialog.expandHeight();
                expanded = true;
            }
        });
    }

    // -----------------------------
    // Basic form functionality
    // -----------------------------
    that.show = function( setLastPosition, savedOffsets ) {
        dialog.show( setLastPosition, savedOffsets );
        setDialogSize();
        // Bind tabcatcher (for circular navigation) and highlighters for radio/checkboxes
        dialog.bindTabListeners(spec.firstFieldSelector);
    };

    that.hide = function() {
        dialog.hide();
        dialog.unbindTabListeners();
    };

    that.isVisible = function() {
        return dialog.isVisible();
    };

    that.minimize = function() {
        dialog.minimize();
    };

    that.resetForms = function() {
        var dialogContainer = dialog.getDialog();
        dialogContainer.find('form')[0].reset();
        dialog.resetExpanded();
    };

    that.disableForms = function() {
        var dialogContainer = dialog.getDialog();
        dialogContainer.find('input').prop('disabled', true);
        dialogContainer.find('textarea').prop('disabled', true);
        dialogContainer.find('select').prop('disabled', true);
        dialogContainer.find('button').prop('disabled', true);
    };

    that.enableForms = function() {
        if (!el8Globals.READ_ONLY) {
            var dialogContainer = dialog.getDialog();
            dialogContainer.find('input').prop('disabled', false);
            dialogContainer.find('textarea').prop('disabled', false);
            dialogContainer.find('select').prop('disabled', false);
            dialogContainer.find('button').prop('disabled', false);
        }
    };

    that.setDialogHeight = function(height) {
        dialog.setHeight(height);
        setDialogSize();
    };

    that.getDialogHeight = function() { return container.height(); };

    if (el8Globals.READ_ONLY) {
        that.disableForms();
    }

    return that;
};
